import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Icon,
  Dimmer,
  Loader,
  Message,
  Segment,
} from "semantic-ui-react";
import InventoryCard from "./InventoryCard";
import axios from "../../../../../../apis/dvdlocator";
import { bulkEditInventoryIds } from "./inventoryRows";

// `rows` are Inventory grid rows, nested by table ({ supply, inventory }).
// The grid doesn't select every inventory column (no title), so each
// inventory is loaded from GET /supply?inventoryId=, like Inventory Details.
const InventoryBulkEdit = ({ inventory: rows, open, onClose }) => {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const ids = bulkEditInventoryIds(rows);
    setLoading(true);
    setLoadError(null);
    Promise.all(
      ids.map((id) =>
        axios
          .get(`/supply?inventoryId=${id}`)
          .then((res) => res.data.find((unit) => unit.inventory_id === id))
      )
    )
      .then((units) => {
        if (!cancelled) setInventory(units.filter(Boolean));
      })
      .catch((error) => {
        console.error("Error loading inventory for bulk edit:", error);
        if (!cancelled) setLoadError("Failed to load the selected inventory.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [rows]);

  const handlePartNumberEdit = async (inventoryId, newPartNumber) => {
    await axios.put(`/inventory/${inventoryId}`, { partNumber: newPartNumber });

    setInventory((prevInventory) =>
      prevInventory.map((item) =>
        item.inventory_id === inventoryId
          ? { ...item, part_number: newPartNumber }
          : item
      )
    );
  };

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Header>
        <Icon name="edit" />
        Inventory Bulk Edit
      </Modal.Header>
      <Modal.Content scrolling>
        {loading ? (
          // A bare Loader is invisible inside a Modal; it needs its own Dimmer
          <Segment basic style={{ minHeight: "10em" }}>
            <Dimmer active inverted>
              <Loader inverted content="Loading inventory..." />
            </Dimmer>
          </Segment>
        ) : loadError ? (
          <Message negative>{loadError}</Message>
        ) : inventory.length === 0 ? (
          <Message warning>
            None of the selected rows has an inventory record.
          </Message>
        ) : (
          inventory.map((item) => (
            <InventoryCard
              key={item.inventory_id}
              inventory={item}
              onPartNumberEdit={handlePartNumberEdit}
            />
          ))
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} primary>
          <Icon name="checkmark" />
          Done
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default InventoryBulkEdit;
